// extracted by mini-css-extract-plugin
module.exports = {"header":"Role_header_2TVxG","buttonGroup":"Role_buttonGroup_1XQ4C","spacing":"Role_spacing_2LE5G"};